import axios from 'axios';
import { env } from 'env';
import { IPixelStreamingLog } from '../interfaces/pixelStreamingLogs';

export default class PixelStreamingLogsService {
  static createPixelStreamingLog(
    iPixelStreamingLog: IPixelStreamingLog,
  ): Promise<number> {
    return axios.post(
      `${env.REACT_APP_API_URL}api/v2/pixel-streaming/logs`,
      iPixelStreamingLog,
    );
  }
}
